export const AUTH_SCOPES = {
  USER_READ:  ["User.Read"],
  API_ACCESS: [`api://${process.env.REACT_APP_MSAL_CLIENT_ID}/access_as_user`],
};

// Role values must match exactly what is configured in Azure App Roles
export const ROLES = {
  PMO:        "PMO",
  SCG:        "SCG",
  MAC_LEADER: "MACleaders",
  ADMIN:      "PSIadmin",
  HR:         "HR",
  FINANCE:    "Finance",
  BD:         "BD",
  TAC:        "TAC",
  CSG:        "CSG",
};

// Only these roles can access PSI360 - rest are blocked
export const ALLOWED_ROLES = [
  ROLES.PMO,
  ROLES.SCG,
  ROLES.MAC_LEADER,
  ROLES.ADMIN,
  ROLES.HR,
  ROLES.FINANCE,
  ROLES.BD,
  ROLES.TAC,
  ROLES.CSG,
];

// Each role lands on its own separate dashboard after login
export const ROLE_DEFAULT_ROUTES = {
  [ROLES.PMO]:        "/pmo/dashboard",
  [ROLES.SCG]:        "/scg/dashboard",
  [ROLES.MAC_LEADER]: "/mac/dashboard",
  [ROLES.ADMIN]:      "/admin/dashboard",
  [ROLES.HR]:         "/hr/dashboard",
  [ROLES.TAC]:        "/tsg/dashboard",
  [ROLES.CSG]:        "/csg/dashboard",
};